import {gql} from '@apollo/client';

export default gql`
  query searchProducts($query: String!, $companyId: ID!) {
    productSearch(query: $query, companyId: $companyId) {
      id
      name
      slug
    }
  }
`;
